/** Presentation formatting. Pure, no I/O, no opinions about the business. */

export function formatDate(value: string | null | undefined): string {
  if (!value) return 'Not stated'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}
